export class User {
	name: string;
	eMail: string;
	canDisableStatics: boolean;
	hasAccessToERPExport: boolean;
	hasAccessToCRMExport: boolean;
}
